/**
 * Normalizes `roomNames[]` entries whether they are strings or [name, qty] tuples.
 */
export function formatRoomNameEntry(entry) {
  if (entry == null) return "";
  if (typeof entry === "string") return entry;
  if (Array.isArray(entry)) {
    if (entry.length >= 2) {
      const name = entry[0];
      const qty = Number(entry[1]) || 1;
      return qty > 1 ? `${qty} × ${name}` : String(name ?? "");
    }
    return String(entry[0] ?? "");
  }
  return String(entry);
}
